package pl.michal_cyran.portfolio

import Res

val Res.locales get() = listOf("en", "pl")